var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "59px",
    viewBox: "0 0 63 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-without-login",
    transform: "translate(-338.000000, -493.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(318.000000, 402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(20.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "auto_awesome_black_24dp-(1)",
    transform: "translate(55.683277, 42.602910) rotate(-36.000000) translate(-55.683277, -42.602910) translate(25.683277, 12.102910)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 1,
    y: 1.13686838e-13,
    width: 59,
    height: 59
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.458333, 6.458333)",
    fillRule: "nonzero",
    fill: "#4E5B73"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "8.07648624 16.0753337 10.5764862 10.5753337 16.0764862 8.07533371 10.5764862 5.57533371 8.07648624 0.0753337083 5.57648624 5.57533371 0.0764862396 8.07533371 5.57648624 10.5753337"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "6.2449823 41.7799208 4.3699823 45.9049208 0.244982299 47.7799208 4.3699823 49.6549208 6.2449823 53.7799208 8.1199823 49.6549208 12.2449823 47.7799208 8.1199823 45.9049208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.642415,23.3735737 L18.954915,13.0610737 L14.267415,23.3735737 L3.95491503,28.0610737 L14.267415,32.7485737 L18.954915,43.0610737 L23.642415,32.7485737 L33.954915,28.0610737 L23.642415,23.3735737 Z M20.811165,29.9173237 L18.954915,34.0048237 L17.098665,29.9173237 L13.011165,28.0610737 L17.098665,26.2048237 L18.954915,22.1173237 L20.811165,26.2048237 L24.898665,28.0610737 L20.811165,29.9173237 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4E5B73",
    fillRule: "nonzero",
    points: "35.663119 24.1144968 34.413119 26.8644968 31.663119 28.1144968 34.413119 29.3644968 35.663119 32.1144968 36.913119 29.3644968 39.663119 28.1144968 36.913119 26.8644968"
  })), /*#__PURE__*/React.createElement("g", {
    id: "auto_awesome_black_24dp-(1)-copy",
    transform: "translate(22.000000, 72.000000) rotate(180.000000) translate(-22.000000, -72.000000) translate(0.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 2,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.000000)",
    fillRule: "nonzero",
    fill: "#4E5B73"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "27 13.3333333 29.0833333 8.75 33.6666667 6.66666667 29.0833333 4.58333333 27 0 24.9166667 4.58333333 20.3333333 6.66666667 24.9166667 8.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "35 27.3333333 32.9166667 31.9166667 28.3333333 34 32.9166667 36.0833333 35 40.6666667 37.0833333 36.0833333 41.6666667 34 37.0833333 31.9166667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,18.1666667 L13.3333333,9 L9.16666667,18.1666667 L0,22.3333333 L9.16666667,26.5 L13.3333333,35.6666667 L17.5,26.5 L26.6666667,22.3333333 L17.5,18.1666667 Z M14.9833333,23.9833333 L13.3333333,27.6166667 L11.6833333,23.9833333 L8.05,22.3333333 L11.6833333,20.6833333 L13.3333333,17.05 L14.9833333,20.6833333 L18.6166667,22.3333333 L14.9833333,23.9833333 Z",
    id: "Shape"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.e40fd3d78786b1cfe4fd82c5d2684902.svg";
export { ForwardRef as ReactComponent };